import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73336558"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "Base_price" }
const _hoisted_4 = { class: "Base_one Base_one_bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "起购门店数", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "store" }, "店", -1))
const _hoisted_7 = { class: "Base_one" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门店单价", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"8px"} }, "元/店/年（一年365天，按独立商户计算）", -1))
const _hoisted_10 = { class: "switch_b" }
const _hoisted_11 = { class: "b_two_txt" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "b1_10" }, "折扣数值只能输入1-10以内的整数或1位数小数", -1))
const _hoisted_13 = {
  key: 0,
  class: "Discount_price"
}
const _hoisted_14 = { class: "Discount_price_son" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt_one" }, "折扣价格-6个月", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt_two" }, "折", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_18 = { class: "Discount_price_son" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt_one" }, "折扣价格-12个月", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt_two" }, "折", -1))
const _hoisted_21 = { class: "Discount_price_son" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt_one" }, "折扣价格-24个月", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt_two" }, "折", -1))
const _hoisted_24 = { class: "Discount_price_son" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt_one" }, "折扣价格-36个月", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt_two" }, "折", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"20px"} }, null, -1))

import { defineComponent, ref, watch } from "vue";
import { paymanagementdiscountswitch, paymanagementgetall, paymanagementupdateconfig, paymanagementgetlogs } from "@/api/Merchantapi";
import { ElMessage } from "element-plus";
import { el, fa } from "element-plus/lib/locale";
import router from "@/router/index";
import axios from "axios";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const gooleshow_store = ref(false);
const gooleshow_save = ref(false);
const num_36 = ref(1);
const num_24 = ref(1);
const num_12 = ref(1);
const num_6 = ref(1);
const num = ref<any>(Math.floor(1));
const store_num = ref(1);
const gooleshow = ref(false);
const gooleId = ref();
const gooleId_store = ref();
const gooletil = ref("谷歌验证");
const gooletxt = ref("说明: 本次操作需要验证身份，请向管理员索要谷歌动态口令进行操作");
const img = ref("/compontsimg/sjicon.png");
const title = ref("基础价格");
const img2 = ref("/compontsimg/hbicon.png");
const title2 = ref("折扣价格");
const headerimg = ref("/compontsimg/ffsz.png");
const headercontent = ref("主要管理商户申请开通门店使用权限的月度、季度、年度费用以及对应的折扣费用等");
const M_title = ref("说明：起购门店数为商户购买门店的最低数量，商户新增门店时则叠加计费，计费方式为:  门店单价 ÷ 365天 × 新增门店 × 剩余天数");
const M_title2 = ref(
  "说明：折扣价格设置后，商户端显示的价格按折扣比例X销售原价（1月按30天计算），计费方式为: 门店单价 ÷ 365天 x 门店数量 x 购买天数 x 折扣率 "
);
const BASE_STORE_NUM = ref<any>({});
const BASE_STORE_PRICE = ref<any>({});
const DISCOUNT_PRICE_6 = ref<any>({});
const DISCOUNT_PRICE_12 = ref<any>({});
const DISCOUNT_PRICE_24 = ref<any>({});
const DISCOUNT_PRICE_36 = ref<any>({});
const EXPIRE_REMIND = ref<any>({});
const value1 = ref(true);
const isMyOpen = ref(false);
const eidtone = ref(false);

watch(gooleshow_store, (gooleshow_store, oldgooleshow) => {
  if (!gooleshow_store) {
    eidtone.value = false;
  }
});
// 每页条数
const handleSizeChange = (val: any) => {
  MyTablelist.value.pageSize = val;
  console.log(isName.value);

  if (isName.value == "DISCOUNT") {
    let par = { pageNum: 1, pageSize: val, ruleKeys: ["DISCOUNT"] };
    datapar.value = par;
  } else {
    let par = { pageNum: 1, pageSize: val, ruleKeys: ["BASE"] };
    datapar.value = par;
  }
  getpaymanagementgetlogs();
};
const onClose = () => {
  getpaymanagementgetall();
};
const onClose2 = () => {
  getpaymanagementgetall();
};
// 分页
const handleCurrentChange = (val: any) => {
  MyTablelist.value.currentPage = val;
  if (isName.value == "DISCOUNT") {
    let par = { pageNum: val, pageSize: 5, ruleKeys: ["DISCOUNT"] };
    datapar.value = par;
  } else {
    let par = { pageNum: val, pageSize: 5, ruleKeys: ["BASE"] };
    datapar.value = par;
  }
  getpaymanagementgetlogs();
};
watch(value1, (gooleshow, oldgooleshow) => {
  if (gooleshow) {
    Discount.value = true;
  }
});
const Closediscount = ref(false); //开启折扣弹窗变量
// const ClosediscountFn = () => {};

// 时间戳转日期
const timestampToTime = (timestamp: string) => {
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  let D = date.getDate() + " ";
  let h = date.getHours() + ":";
  let m = date.getMinutes() + ":";
  let s = date.getSeconds();
  return Y + M + D + h + m + s;
};

// 以下表格
const Basicstable = ref(false);

// 表格分页 -基础价格
const MyTablelist = ref<any>({
  total: 10,
  pageSize: 10,
  currentPage: 1,
});

// 表格数据 -基础价格
const tableDataBasics = ref<any>([]);

// 表格表头 -基础价格
const tableColumn = ref([
  {
    prop: "ruleName",
    label: "类型",
    width: "120px",
  },
  {
    prop: "ruleValueNew",
    label: "变更后数据",
    // width: "300px",
  },
  {
    prop: "ruleValueOld",
    label: "原始数据",
    // width: "300px",
  },
  {
    prop: "createTime",
    label: "变更时间",
    width: "180px",
  },
  {
    prop: "updateAcc",
    label: "操作账号",
    width: "120px",
  },
]);

const datapar = ref<any>({});

//基础价格 查看变更记录
const viewrecord = () => {
  Basicstable.value = true;
  // if (par.ruleKeys) {
  //   datapar.value = par;
  // } else {
  //   datapar.value = { pageNum: 1, pageSize: 5, ruleKeys: ["BASE"] };
  // }
  let par = { pageNum: 1, pageSize: 5, ruleKeys: ["BASE"] };
  datapar.value = par;
  isName.value = "BASE";
  console.log(isName.value);
  getpaymanagementgetlogs();
};

// 获取查看变更记录
const getpaymanagementgetlogs = () => {
  paymanagementgetlogs(datapar.value).then((res) => {
    tableDataBasics.value = res.data.list;
    tableDataBasics.value.forEach((item: any) => {
      item.createTime = timestampToTime(item.createTime);
    });
    MyTablelist.value = {
      total: res.data.total,
      pageSize: res.data.pageSize,
      currentPage: res.data.pageNum,
    };
  });
};
// 以上表格区域 - 勿扰

// 折扣开关
const openswtich = () => {
  paymanagementgetlogs({ ruleKeys: ["SWITCH"] }).then((res) => {
    console.log(res, "折扣开关");
    value1.value = res.data.list[0].ruleValueNew == "on" ? true : false;
    if (value1.value) {
      Discount.value = true;
    }
  });
};

openswtich();
const Discount = ref(false);

const onconfirm = (val: any) => {
  let gId = val.ruleForm.gooleId;
  gooleId.value = gId;
  paymanagementdiscountswitch({ command: gooleId.value, isOpen: value1.value }).then((res) => {
    if (res.code == 1) {
      ElMessage({
        message: "操作成功！",
        type: "success",
      });
    } else {
      ElMessage({
        message: res.msg as string,
        type: "warning",
      });
    }
    openswtich();
    gooleshow.value = false;
  });
};

//是否开启折扣
const switchFn = (val: any) => {
  console.log(val);

  if (val) {
    // Closediscount.value = true;
    gooleshow.value = true;
    Discount.value = true;
  } else {
    Discount.value = false;
    gooleshow.value = true;
  }
};

const onCloseFn = (val: any) => {
  openswtich();
};
const isName = ref("");
//保存折扣
const saveFn = () => {
  gooleshow_save.value = true;
};
const onconfirm_save = (val: any) => {
  paymanagementupdateconfig({
    command: val.ruleForm.gooleId,
    dtoList: [
      {
        ruleKey: "DISCOUNT_PRICE_6",
        ruleValue: num_6.value,
      },
      {
        ruleKey: "DISCOUNT_PRICE_12",
        ruleValue: num_12.value,
      },
      {
        ruleKey: "DISCOUNT_PRICE_24",
        ruleValue: num_24.value,
      },
      {
        ruleKey: "DISCOUNT_PRICE_36",
        ruleValue: num_36.value,
      },
    ],
  }).then((res) => {
    if (res.code == 1) {
      ElMessage({
        message: "操作成功！",
        type: "success",
      });
    } else {
      ElMessage({
        message: res.msg as string,
        type: "warning",
      });
    }

    gooleshow_save.value = false;
  });
  getpaymanagementgetall();
};

//折扣价格 查看变更记录
const viewdiscount = () => {
  Basicstable.value = true;
  let par = { pageNum: 1, pageSize: 5, ruleKeys: ["DISCOUNT"] };
  datapar.value = par;
  isName.value = "DISCOUNT";

  getpaymanagementgetlogs();
};

const onconfirm_store = (val: any) => {
  gooleId_store.value = val.ruleForm.gooleId;
  paymanagementupdateconfig({
    command: gooleId_store.value,
    dtoList: [
      {
        ruleKey: "BASE_STORE_NUM",
        ruleValue: store_num.value,
      },
      {
        ruleKey: "BASE_STORE_PRICE",
        ruleValue: num.value,
      },
    ],
  }).then((res) => {
    if (res.code == 1) {
      value1.value == val;
      ElMessage({
        message: res.msg as string,
        type: "success",
      });
    } else {
      value1.value == val;
      ElMessage({
        message: res.msg as string,
        type: "warning",
      });
    }
    gooleshow_store.value = false;
    console.log(val, "22222222222222222222222222222222");
    getpaymanagementgetall();
  });
};
// 请求
const getpaymanagementgetall = () => {
  paymanagementgetall().then((res) => {
    console.log(res, "数据");
    BASE_STORE_NUM.value = res.data[0];
    BASE_STORE_PRICE.value = res.data[1];
    DISCOUNT_PRICE_6.value = res.data[2];
    DISCOUNT_PRICE_12.value = res.data[3];
    DISCOUNT_PRICE_24.value = res.data[4];
    DISCOUNT_PRICE_36.value = res.data[5];
    EXPIRE_REMIND.value = res.data[6];

    // 赋值
    store_num.value = BASE_STORE_NUM.value.ruleValue;
    num.value = BASE_STORE_PRICE.value.ruleValue;
    num_6.value = DISCOUNT_PRICE_6.value.ruleValue;
    num_12.value = DISCOUNT_PRICE_12.value.ruleValue;
    num_24.value = DISCOUNT_PRICE_24.value.ruleValue;
    num_36.value = DISCOUNT_PRICE_36.value.ruleValue;
  });
};
getpaymanagementgetall();
const eidtoneFn = () => {
  if (eidtone.value) {
    gooleshow_store.value = true;
  } else {
    eidtone.value = !eidtone.value;
  }
};
const mdDj = (val: number) => {
  num.value = num.value.replace(/[^\d]/g, "");
};

// const cancelFn = () => {
//   router.go(-1);
// };

return (_ctx: any,_cache: any) => {
  const _component_Pageheader = _resolveComponent("Pageheader")!
  const _component_Moduletitle = _resolveComponent("Moduletitle")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_GoogleDialogue = _resolveComponent("GoogleDialogue")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pageheader, {
      title: "付费设置",
      img: headerimg.value,
      text: headercontent.value
    }, null, 8, ["img", "text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Moduletitle, {
          title: title.value,
          img: img.value,
          radius: "true",
          text: M_title.value
        }, null, 8, ["title", "img", "text"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_el_input_number, {
              modelValue: store_num.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((store_num).value = $event)),
              disabled: !eidtone.value,
              min: 1,
              max: 100000,
              controls: false
            }, null, 8, ["modelValue", "disabled"]),
            _hoisted_6,
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: eidtoneFn,
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(eidtone.value ? "保存" : "编辑"), 1)
              ]),
              _: 1
            }),
            _createElementVNode("span", {
              class: "bj",
              onClick: viewrecord
            }, "查看变更记录")
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input_number, {
              modelValue: num.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((num).value = $event)),
              disabled: !eidtone.value,
              onKeyup: _withModifiers(mdDj, ["stop"]),
              precision: 0,
              min: 1,
              max: 100000,
              step: 1,
              controls: false,
              "step-strictly": ""
            }, null, 8, ["modelValue", "disabled", "onKeyup"]),
            _hoisted_9
          ])
        ]),
        _createVNode(_component_Moduletitle, {
          title: title2.value,
          img: img2.value,
          radius: "false",
          text: M_title2.value
        }, null, 8, ["title", "img", "text"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_switch, {
            modelValue: value1.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value1).value = $event)),
            style: {"margin":"0 6px 0 27px"},
            onChange: switchFn
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(value1.value ? "关闭折扣" : "开启折扣"), 1),
          _hoisted_12
        ]),
        (value1.value == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_el_input_number, {
                  modelValue: num_6.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((num_6).value = $event)),
                  disabled: !Discount.value,
                  min: 1,
                  max: 10,
                  controls: false
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_16,
                (Discount.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      round: "",
                      onClick: saveFn
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "bj",
                  onClick: viewdiscount
                }, "查看变更记录")
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_el_input_number, {
                  modelValue: num_12.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((num_12).value = $event)),
                  disabled: !Discount.value,
                  min: 1,
                  max: 10,
                  controls: false
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_el_input_number, {
                  modelValue: num_24.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((num_24).value = $event)),
                  disabled: !Discount.value,
                  min: 1,
                  max: 10,
                  controls: false
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_23
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_el_input_number, {
                  modelValue: num_36.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((num_36).value = $event)),
                  disabled: !Discount.value,
                  min: 1,
                  max: 10,
                  controls: false
                }, null, 8, ["modelValue", "disabled"]),
                _hoisted_26
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_GoogleDialogue, {
      title: gooletil.value,
      text: gooletxt.value,
      dialogVisible: gooleshow.value,
      "onUpdate:dialogVisible": _cache[7] || (_cache[7] = ($event: any) => ((gooleshow).value = $event)),
      onChangeNavfu: onconfirm,
      onOnCloseFn: onCloseFn
    }, null, 8, ["title", "text", "dialogVisible"]),
    _createVNode(_component_GoogleDialogue, {
      title: gooletil.value,
      text: gooletxt.value,
      dialogVisible: gooleshow_store.value,
      "onUpdate:dialogVisible": _cache[8] || (_cache[8] = ($event: any) => ((gooleshow_store).value = $event)),
      onOnClose: onClose,
      onChangeNavfu: onconfirm_store
    }, null, 8, ["title", "text", "dialogVisible"]),
    _createVNode(_component_GoogleDialogue, {
      title: gooletil.value,
      onOnClose: onClose2,
      text: gooletxt.value,
      dialogVisible: gooleshow_save.value,
      "onUpdate:dialogVisible": _cache[9] || (_cache[9] = ($event: any) => ((gooleshow_save).value = $event)),
      onChangeNavfu: onconfirm_save
    }, null, 8, ["title", "text", "dialogVisible"]),
    _createVNode(_component_el_dialog, {
      modelValue: Basicstable.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((Basicstable).value = $event)),
      title: '查看变更记录',
      width: "70%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MyTable, {
          tableData: tableDataBasics.value,
          ifselection: false,
          isPagination: true,
          isIndex: true,
          isHeight: false,
          tableColumn: tableColumn.value,
          onHandleCurrentChange: handleCurrentChange,
          onHandleSizeChange: handleSizeChange,
          total: MyTablelist.value.total,
          pageSize: MyTablelist.value.pageSize,
          currentPage: MyTablelist.value.currentPage
        }, {
          slotName: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                false
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(row), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["tableData", "tableColumn", "total", "pageSize", "currentPage"]),
        _hoisted_28
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})